import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@jbnl/shared-ui";

/**
 * Two panes from `xl`, the first width where both fit - splitting at `md` left the detail 136
 * pixels (ADR-0063). CSS rather than a matchMedia hook, which answers "desktop" on a phone's
 * first paint. The list pane does not scroll within itself; every list it wraps is paginated.
 */
export function ListDetail({
  list,
  detail,
  selected,
  backLabel,
  onBack,
}: {
  list: ReactNode;
  detail: ReactNode;
  selected: boolean;
  backLabel: string;
  onBack: () => void;
}) {
  return (
    <div className="grid gap-6 xl:grid-cols-[30rem_1fr]">
      <div
        className={cn(
          "min-w-0 xl:sticky xl:top-20 xl:self-start",
          selected && "hidden xl:block",
        )}
      >
        {list}
      </div>

      <div className={cn("min-w-0", !selected && "hidden xl:block")}>
        {selected && (
          <Button
            variant="outline"
            size="sm"
            className="mb-4 xl:hidden"
            onClick={onBack}
          >
            <ChevronLeft />
            {backLabel}
          </Button>
        )}
        {detail}
      </div>
    </div>
  );
}
